import { OCCUPANT_CREATE } from 'common-app/api/query/occupant-create';
import { OCCUPANT_READ } from 'common-app/api/query/occupant-read';
import { OCCUPANT_WRITE } from 'common-app/api/query/occupant-write';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getOccupant, newOccupant, setOccupant } from './data';
export default [
    {
        request: {
            query: OCCUPANT_READ,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                read_occupant: getOccupant().map((p) => (Object.assign(Object.assign({}, p), { __typename: 'OccupantDto' }))),
            },
        },
    },
    {
        request: {
            query: OCCUPANT_CREATE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                create_occupant: Object.assign(Object.assign({}, newOccupant()), { __typename: 'OccupantDto' }),
            },
        },
    },
    {
        request: {
            query: OCCUPANT_WRITE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            let occupant = variables === null || variables === void 0 ? void 0 : variables.participants;
            setOccupant(occupant);
            return {
                data: {
                    write_occupant: occupant.map((p) => (Object.assign(Object.assign({}, p), { __typename: 'OccupantDto' }))),
                },
            };
        },
    },
];
